import React from 'react';
import { formatAssociatedOrderNumberForDisplay } from '../../../util';
import { obfuscateSensitiveData, formatOrderDateToLocalTime } from '../../../util/formatUtil';
import * as sensitiveDataTypes from 'constants/sensitiveDataTypes';
import { Row, TableData } from 'components/common/tableElements';

function getStatus(order) {
  if (order.cancelled_at || ['refunded'].includes(order.financial_status)) {
    return 'Cancelled';
  }

  if (order.closed_at && ['fulfilled', 'partial'].indexOf(order.fulfillment_status) === -1) {
    return 'Closed';
  }

  if (['fulfilled', 'partial'].includes(order.fulfillment_status)) {
    return 'Shipped';
  }

  return 'Open';
}

const ShopifyOrderSearchResult = ({ result, clickAction, even }) => {
  const orderStatus = getStatus(result);
  const risk = result.riskLevel || 'Unknown';
  const firstName = !!result.customer && result.customer.first_name;
  const lastName = !!result.customer && obfuscateSensitiveData(result.customer.last_name, sensitiveDataTypes.lastName);
  const fullName = firstName + ' ' + lastName;

  return (
    <Row onClick={() => clickAction(result)} hoverPointer={true} even={even}>
      <TableData>{formatAssociatedOrderNumberForDisplay(result.name)}</TableData>
      <TableData>{formatOrderDateToLocalTime(result['created_at'], 'shopify')}</TableData>
      <TableData>{fullName}</TableData>
      <TableData>{orderStatus}</TableData>
      <TableData>{risk}</TableData>
    </Row>
  );
};

export default ShopifyOrderSearchResult;
